import { render, staticRenderFns } from "./awardExportTran.vue?vue&type=template&id=1b5b31a6"
import script from "./awardExportTran.vue?vue&type=script&lang=js"
export * from "./awardExportTran.vue?vue&type=script&lang=js"
import style0 from "./awardExportTran.vue?vue&type=style&index=0&id=1b5b31a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports